export function emailTemplateMapper(emailTemplate) {
  return {
    id: emailTemplate.id,
    name: emailTemplate.name,
    rawHtml: emailTemplate.raw_html,
    rawCss: emailTemplate.raw_css,
    compiledHtmlCss: emailTemplate.compiled_html_css,
    previewImgUrl: emailTemplate.preview_img_url,
    isPublic: emailTemplate.is_public ?? false,
    editorType: emailTemplate.editor_type || 'stripo',
  };
}
